import { render, staticRenderFns } from "./InstituteProfileQuestions.vue?vue&type=template&id=43710e04"
import script from "./InstituteProfileQuestions.vue?vue&type=script&lang=js"
export * from "./InstituteProfileQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports